import { useContext } from 'react';
import { useConfigurableHotkey } from '@/hooks/useConfigurableHotkey';
import { HOTKEY_IDS } from '@/lib/hotkeys/registry';
import { AuthContext } from '@/context/auth.context';
import { SendFeedbackMenuButton } from './SendFeedbackMenuButton';
import { useFeedbackPanel } from '@/context/feedback-panel.context';
import { FeedbackPanel } from '@/components/feedback-panel/FeedbackPanel';

/**
 * The sidebar Help-menu "Send feedback" entry (⌘⇧F). Opens the docked
 * feedback panel in capture mode, which screenshots the current page. This
 * component is mounted once by the authenticated layout, so the panel it
 * renders outlives page navigation.
 */
export function PanelFeedbackButton() {
  const { currentUser } = useContext(AuthContext);
  const panel = useFeedbackPanel();
  const open = panel.session !== null;

  // react-hotkeys-hook skips key events from inputs/textareas by default, so
  // this won't fire while the user is typing in a field.
  useConfigurableHotkey(
    HOTKEY_IDS.feedback,
    () => panel.open('capture'),
    { preventDefault: true },
    [currentUser, panel],
  );

  if (!currentUser) return null;

  return (
    <>
      <SendFeedbackMenuButton
        onClick={() => panel.open('capture')}
        disabled={open}
      />

      {/* The docked panel lives here, in the persistent layout, so a draft
          (text + screenshots) survives navigating to other pages. It is
          position: fixed, so where it renders in the tree does not matter. */}
      <FeedbackPanel />
    </>
  );
}
